import CONFIRM_DIALOGS from './confirm-dialog/de';
import ERROR_DIALOGS from "./error-dialog/de";
import RESULT_DIALOGS from "./result-dialog/de";

export default {
    BUTTONS: {
        SUBMIT: "Absenden",
        PREVIOUS: "Zurück",
        NEXT: "Weiter",
        VIEW: "Ansicht",
        UPLOAD: "Hochladen",
        CLOSE: "Schließen",
        DELETE: "Löschen",
        CANCEL: "Abbrechen",
        YES: "Ja",
        NO: "Nein",
        OK: "OK"
    },
    OPTIONS: {
        YES: "Ja",
        NO: "Nein"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Dieses Feld ist erforderlich."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Wird verarbeitet, bitte warten...",
        STEP_OF: "Schritt {0} von {1}"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Eine Datei hier ablegen oder zum Hochladen klicken",
        MAXIMUM_UPLOAD_SIZE: "Maximale Uploadgröße {0}MB",
        FILE_EXCEED_MAXIMUM: "Dateigröße überschreitet {0}MB.",
        FILE: "Datei"
    },
    BOOKING_DIALOG: {
        LABEL: {
            START_TIME: "Startzeit",
            END_TIME: "Endzeit",
            END_DATE: "Enddatum",
            SELECT_CLIENT: "Client auswählen",
            ASSIGNED_CANDIDATE: "Möchten Sie diesen Job zuweisen?",
            REPEAT: "Wiederholen?",
            REPEAT_UNTIL: "Wiederholen bis",
            REPEAT_EVERY: "Alle wiederholen",
            REPEAT_ON: "Wiederholen ein",
            BOOKING_ADDRESS: "Buchungsadresse",
            ADDRESS_LINE2: "Adresszeile 2",
            CITY: "Stadt",
            STATE: "Staat",
            ZIP_CODE: "Postleitzahl",
            NUMBER_CHILDREN: "Wie viele Kinder werden betreut?",
            SELECT_JOB_CATEGORY: "Jobkategorie auswählen"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Tage", "Wochen"],
            REPEAT_ON: [
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag",
                "Sonntag"]
        }
    },
    CONFIRM_DIALOGS: CONFIRM_DIALOGS,
    ERROR_DIALOGS: ERROR_DIALOGS,
    RESULT_DIALOGS: RESULT_DIALOGS
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/de.js